(function ($) {
	var isTablet = setIsTablet($(window).width());

	function setIsTablet(width) {
		return width < 900;
	}

	$(window).resize(function () {
		isTablet = setIsTablet($(window).width());
	});

	const tableOfContents = $('.table-of-contents');
	const tableOfContentsHeading = $('.table-of-contents h3');
	const tableOfContentsList = $('.table-of-contents ul');
	let tableOfContentsItems = null;

	if (tableOfContents.length > 0) {
		$('aside .table-of-contents ul').attr('id', 'table-of-contents');
		tableOfContentsItems = $('.site-main article').first().find('h2').not('.h3');
		tableOfContentsHeading.on('click', function (event) {
			event.preventDefault();
			if (isTablet) {
				tableOfContents.toggleClass('open');
				tableOfContentsList.slideToggle('fast');
			}
		});
	}

	if (tableOfContentsItems !== null && tableOfContentsItems.length > 0) {
		tableOfContentsItems.each(function (index) {
			const navItem = $(this).text().replace(/(<([^>]+)>)/gi, "");
			if (navItem !== '') {
				$(this).prepend(`<span id="item-${index}" class="anchor"></span>`);
				tableOfContentsList.append(`<li><a href="#item-${index}">${navItem}</a></li>`);
			}
		});
	} else {
		tableOfContents.css('display', 'none');
	}
})(jQuery);